import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiService } from '../api/api.service';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { OddsEndsService } from '../odds-ends/odds-ends.service';

@Injectable({
    providedIn: 'root'
})
export class ActionService {

    private subject = new Subject();
    private error = new Subject();
    private successMessage = new Subject();

    constructor(
        private api: ApiService,
        private oddsEndService: OddsEndsService
    ) { }

    /**
     * Sets data in the subject which is used within the components to process actions
     * @param data
     */
    setAction(data) {

        if (data.action == 'clear_cart') {
            localStorage.setItem('cart', null);
        } else if (data.action == 'clear-megamenus') {
            // Nothing
        } else if (data.action == 'filter-posts-by-title' || data.action == 'filter-posts-by-tag' || data.action == 'fetch-posts') {
            // Nothing
        } else if (data.action == 'gtm') {
            // Nothing
        } else {
            let cart: any = localStorage.getItem('cart');
            if (cart) {

                if (data.data) {
                    cart = JSON.parse(cart);
                    //Loop through cart and check if monthly and region match
                    let monthMatch = true;
                    let regionKeyMatch = true;
                    let institutionMatch = true;
                    let notInCartAlready = true;

                    let cartJustEmptryArray = false;
                    if (cart && cart.length == 1 && cart[0] == null) {
                        cartJustEmptryArray = true;
                    }

                    if (cart && !cartJustEmptryArray) {
                        cart.forEach(product => {
                            if (
                                (product.PaymentMonthly == 1 || product.PaymentMonthly == 0) &&
                                (data.data.PaymentMonthly == 1 || data.data.PaymentMonthly == 0) &&
                                (data.data.PaymentMonthly != product.PaymentMonthly)
                            ) {
                                monthMatch = false;
                            }
                            if ((product.RegionKey && data.data.RegionKey) && (product.RegionKey != data.data.RegionKey)) {
                                regionKeyMatch = false;
                            }

                            if (product?.catalystSubject?.CourseKey?._text != data?.data?.catalystSubject?.CourseKey?._text) {
                                institutionMatch = false;
                            }

                            if (product?.product?.ProductKey?._text == data?.data?.product?.ProductKey?._text) {
                                notInCartAlready = false;
                            }
                        });

                    } else {
                        cart = [];
                    }


                    if (monthMatch && regionKeyMatch && institutionMatch && notInCartAlready) {
                        cart.push(data.data);
                        localStorage.setItem('cart', JSON.stringify(cart));
                        this.error.next('');
                    } else {
                        let error = 'An error occured';

                        if (!monthMatch) {
                            error = "The payment method must match the payment method of the other items in your cart. ";
                        }
                        if (!regionKeyMatch) {
                            error = "The region must match the region of the other items in your cart. Either clear your cart to add this product or cancel.";
                        }
                        if (!institutionMatch) {
                            error = 'You can only purchase items from 1 institution at a time, per checkout. If you would like to empty your current cart and add this item, then click the "Clear Cart and Add Item" button below. Alternatively, close this message and continue to add only items within the same institute of the items already in your cart.';
                        }
                        if (!notInCartAlready) {
                            error = "This item is already in your cart";
                        }

                        data.error = error;

                        if (!regionKeyMatch || !institutionMatch) {
                            let btnText = "Clear Cart";
                            if (!institutionMatch) {
                                btnText = "Clear Cart and Add Item";
                            }
                            Swal.fire({
                                title: 'Could not add to cart.',
                                text: error,
                                // icon: 'warning',   
                                confirmButtonText: btnText,
                                allowOutsideClick: false,
                                showCloseButton: true,
                                customClass: 'swal-ibtc',
                                position: 'top'
                            }).then((result) => {
                                if (result.value) {
                                    console.log("changing here");

                                    //Change payment method
                                    cart = this.ensureArray(data.data);
                                    localStorage.setItem('cart', JSON.stringify(cart));
                                    if (!institutionMatch) {
                                        // Only firing this so the listeners know we have changed it

                                        this.oddsEndService.setAction({
                                            action: "updated"
                                        });

                                        this.error.next('');
                                    }
                                } else {
                                    console.log(error);
                                    //this.error.next('');
                                }
                            });

                        } else {
                            console.log(error);
                            this.error.next(error);
                        }




                    }

                } else {
                    console.log('Not really changing storage, just firing for listeners.');
                }

            } else {

                if (data.action == 'update_entire_cart') {
                    cart = data.data;
                } else {
                    cart = [];
                    if (data.data) {
                        cart.push(data.data);
                    }

                }

                localStorage.setItem('cart', JSON.stringify(cart));
                this.error.next('');
            }

            //We must also update the cart on Refresh API
            this.api.cart_persist().subscribe(res => {
            }, (err) => {
                console.log('got res errrr!');
            });
            //if we are not clearing the cart then we must sync the changes to the catalyst API
            this.api.sync_user_cart('asd');


        }

        this.subject.next(data);

    }


    ensureArray(possibleArray) {
        if (possibleArray) {
            if (Array.isArray(possibleArray)) {
                return possibleArray;
            } else {
                return [possibleArray];
            }
        } else {
            return [];
        }
    }
    /**
     * Returns the Subject as an observable which is used within the components to process actions
     */
    getAction(): Observable<any> {

        return this.subject.asObservable();

    }

    /**
     * Returns the Subject as an observable which is used within the components to process actions
     */
    returnError(): Observable<any> {
        return this.error.asObservable();
    }

    /**
   * Returns the Subject as an observable which is used within the components to process actions
   */
    returnSuccess(): Observable<any> {
        return this.successMessage.asObservable();
    }
}
